export default "__VITE_ASSET__DNfmJEQk__"